import { ClimbingArea } from "../types";

// Simple in-memory cache with 5 minute TTL
interface CacheEntry {
  data: ClimbingArea;
  timestamp: number;
}

const cache = new Map<string, CacheEntry>();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function getCachedArea(areaId: string): ClimbingArea | null {
  const entry = cache.get(areaId);

  if (!entry) {
    return null;
  }

  // Check if cache entry is still valid
  const isExpired = Date.now() - entry.timestamp > CACHE_TTL;
  if (isExpired) {
    cache.delete(areaId);
    return null;
  }

  return entry.data;
}

export function setCachedArea(areaId: string, data: ClimbingArea): void {
  cache.set(areaId, {
    data,
    timestamp: Date.now(),
  });
}

export function clearAreaCache(): void {
  cache.clear();
}
